exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".autorizacion {\n  width: 120px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/public/components/autorizacion/autorizacion.component.css
// module id = ../../../../../src/app/public/components/autorizacion/autorizacion.component.css
// module chunks = main